import BasePropertyView from 'BasePropertyView.js';
import Template from 'behaviors/properties/main/redirect-url.ejs';
import formulaModal from 'common-views/MainFormulaModalView.js';
//=====================================================================
//
// An instance of this view represents a redirect url.
//
// Casey Justus, May 16, 2016 
//
//=====================================================================

class MainRedirectURL extends BasePropertyView {

    initialize( opts ) {
 
        console.log('redir url init');
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change select'                 : 'updateAttributes',
            'change input[type=radio]'      : 'updateAttributes',
            'change input[type=text]'       : 'updateAttributes',
            'blur input[type=text]'         : 'lostFocus',
            'focus input[type=text]'        : 'getFocus',
            'click #Formula'                : 'showFormulaModal'
        };

        if(!this.model.get('redirectURLTitle')){
            this.model.set('redirectURLTitle','', {silent: true});
        }

        if(!this.model.get('textOrNumber')){
            this.model.set('textOrNumber','', {silent: true});
        }

        if(!this.model.get('textOrNumberReadOnly')){
            this.model.set('textOrNumberReadOnly','', {silent: true});
        }

        if(!this.model.get('fieldValue')){
            this.model.set('fieldValue','', {silent: true});
        }

        if(!this.model.get('specialDisabled')){
            this.model.set('specialDisabled','', {silent: true});
        }

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    updateAttributes(ev) {
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        this.model.set( propName, propVal );

        this.model.set({
            textOrNumberReadOnly: 'readonly',
            specialDisabled: 'disabled'    
        }, {silent:true});
        
        if (this.model.get('redirectType') === 'textOrNumber'){
            this.model.set({textOrNumberReadOnly: ''}, {silent:true});
      
        }else if(this.model.get('redirectType') === 'special'){
            this.model.set({specialDisabled: ''}, {silent:true});
        }

        this.render();
    }

    showFormulaModal(ev) {
        ev.preventDefault();
        const factoryKey= 'modal';
        const attributes = {formulaParameter: this.model.get('formulaParameter')};

        var sfModal = new formulaModal({model: new Model(attributes), config: {selected: ''}});
        sfModal.render().then((formulaParameter)=>{
            //  Also change the creation of the modal passing the appropiated value on the config
            this.model.set('formulaParameter', formulaParameter, {silent: true});
        }).catch(err => console.log(err));
    }

    render() {
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
       
        $("input:radio[value='"+this.model.get('redirectType')+"']").attr('checked', true);

        $("option[value='"+this.model.get('special')+"']").attr( "selected", true );

        this.delegateEvents();
        return this;
    }

}

export default MainRedirectURL;
